import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  IconButton,
  Typography,
} from '@mui/material';
import CloseIcon from '@diligentcorp/atlas-react-icons/dist/esm/lens/Close.js';

export interface ArchiveFormConfirmModalProps {
  open: boolean;
  setOpen: (open: boolean) => void;
  onConfirm: () => void;
  onCancel: () => void;
  'data-testid'?: string;
}

export const ArchiveFormConfirmModal = ({
  open,
  setOpen: _setOpen,
  onConfirm,
  onCancel,
  'data-testid': dataTestId = 'archive-form-confirm-modal',
}: ArchiveFormConfirmModalProps) => (
  <Dialog
    open={open}
    onClose={onCancel}
    aria-labelledby="archive-form-dialog-title"
    aria-describedby="archive-form-dialog-description"
    data-testid={dataTestId}
  >
    <DialogTitle component="div">
      <Typography variant="h6" component="h2" id="archive-form-dialog-title">
        Archive form
      </Typography>
      <IconButton
        aria-label="Close"
        onClick={onCancel}
        size="small"
        color="inherit"
        data-testid={`${dataTestId}-close`}
      >
        <CloseIcon />
      </IconButton>
    </DialogTitle>
    <DialogContent>
      <DialogContentText id="archive-form-dialog-description">
        When you archive a form, it no longer appears in Reporter Portal and
        employees can&apos;t use it to create and submit reports. You can&apos;t
        undo this.
      </DialogContentText>
    </DialogContent>
    <DialogActions sx={{ justifyContent: 'space-between' }}>
      <Button
        variant="outlined"
        onClick={onCancel}
        data-testid={`${dataTestId}-cancel`}
      >
        Cancel
      </Button>
      <Button
        variant="contained"
        color="destructive"
        onClick={onConfirm}
        autoFocus
        data-testid={`${dataTestId}-confirm`}
      >
        Archive
      </Button>
    </DialogActions>
  </Dialog>
);
